import { formActionTypeId } from '../constants';

const enableStrategy = (action, conditionValue) => ({ key: action.fieldId, value: conditionValue, name: 'enable' });
const actionMap = {
  [formActionTypeId.ENABLE]: enableStrategy,
};

const actionStrategy = ({ action, conditionValue }) => {
  const strategy = actionMap[action?.actionTypeId];
  if (!strategy) return;
  return strategy(action, conditionValue);
};

export default actionStrategy;
